import React from "react";

const Tooltip = ({ error }) => {
    if (!error) return "";

    return (
        <div className="relative w-full">
            <div className="absolute z-[1] left-3 rounded top-2.5">
                <div className="hover-error">
                    <span style={{ whiteSpace: "nowrap" }}>{error}</span>
                </div>
            </div>
        </div>
    );
};

export default Tooltip;
